/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Patterns_DescriptionInputs */



/**
* | output |
* | --- |
* | "Monitor and block sensitive content using regex pattern matching" |
*
* @param {Compliance_Patterns_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_patterns_description = /** @type {((inputs?: Compliance_Patterns_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Patterns_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Überwachen und blockieren Sie sensible Inhalte mit Regex-Muster-Matching")
	return /** @type {LocalizedString} */ ("Monitor and block sensitive content using regex pattern matching")
});